<template>
    <div class="warpper">
        <div class="page-title">账号设置</div>
        <div class="flex flex-direction align-center margin-top-xl">
            <div class="info-container flex align-center">
                <div class="info-tip">手机号</div>
                <div class="info-content flex align-center">
                    <div class="content flex-sub">{{user.phone}}</div>
                    <div class="operate flex-shrink" @click="changePhone">更改</div>
                </div>
            </div>
            <div class="info-container flex align-center margin-top-sm">
                <div class="info-tip">微信账号</div>
                <div class="info-content flex align-center">
                    <i class="iconfont icon-wx"></i>
                    <div class="content flex-sub">{{user.wx_name || '未绑定微信账号'}}</div>
                    <div class="operate flex-shrink" v-if="user.wx_name" @click="unBindWx">解绑</div>
                    <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx2f662cfbfdc8da48&redirect_uri=https://hygl.emof.cn/vw/member/account&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'"
                       class="operate flex-shrink" v-else >绑定</a>
                </div>
            </div>
        </div>
        <phone-change-dialog :applyDialogVisible="applyDialogVisible" @watchState="watchState"></phone-change-dialog>
    </div>
</template>

<script>
    import { bindWx, unBindWx} from "@/api/member";
    import {getQueryString} from '@/utils/utils'
    import PhoneChangeDialog from "@/components/PhoneChangeDialog.vue";
    export default {
        name: "account",
        components: {PhoneChangeDialog},
        data() {
            return {
                ruleForm: {
                    password: '',
                    repassword: '',
                    code: '',
                },
                rules: {
                    password: [
                        {required: true, message: '请输入密码', trigger: 'change'},
                        {min: 6, message: '密码长度需大于等于6个字符', trigger: 'change'}
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'change'}
                    ],
                },
                wx_code: '',
                codeText: '获取验证码', // 验证码文字
                id: null, // 计时器id
                timeId: null, // 一次性计时器id
                applyDialogVisible:false
            }
        },
        created() {
            this.$emit('setIndex', [6, 0], '修改密码')
            this.wx_code = getQueryString('code')
            if (this.wx_code) {
                this.bindWx()
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        methods: {
            async bindWx() {
                let _data = await bindWx(this.wx_code)
                if (_data.status === 200) {
                    this.$message.success('绑定成功')
                    this.$store.state.user.wx_name = _data.data
                    this.$store.dispatch('setUserInfo', this.$store.state.user).then(() => {
                        this.$router.replace('/member/account')
                    })
                }
            },
            unBindWx() {
                this.$confirm('您确定执行解绑微信操作', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let _data = await unBindWx()
                    if (_data.status === 200) {
                        this.$message.success('解绑成功')
                        this.$store.state.user.wx_name = ''
                        this.$store.dispatch('setUserInfo', this.$store.state.user).then(() => {
                        })
                    }
                })

            },
            changePhone() {
                this.applyDialogVisible = true
            },
            watchState() {
                this.applyDialogVisible = false;
            },
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px 30px;
        .info-container {
            .info-tip {
                width: 62px;
                color: #0a2240;
                font-weight: bold;
            }
            .info-content {
                width: 354px;
                height: 50px;
                background-color: #f3f7fb;
                border-radius: 10px;
                border: solid 1px #d1deef;
                padding: 0 12px;
                i {
                    width: 18px;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 18px;
                    color: #9fdda3;
                    background-color: #eeeeee;
                    text-align: center;
                    margin-right: 12px;
                }
                .content {
                    font-size: 14px;
                    color: #94a8c6;
                }
                .operate {
                    font-size: 14px;
                    font-weight: bold;
                    color: #0a2240;
                    margin-left: 20px;
                    cursor: pointer;
                }
            }
        }
    }
</style>